import Button from "../../../../components/button/button";
import CreateAppointment from "../components/createAppointment";
import { useState, useEffect } from "react";
import { isAfter } from "date-fns";
import { useAppointments } from "../../../../hooks/useAppointments";
import { useCustomerContext } from "../../../../utils/customerContext";

function CuDeAppointment({ id }) {
    const [createAppointment, setCreateAppointment] = useState(false);
    const [showCompletedAppointments, setShowCompletedAppointments] = useState(false);
    const { appointments, deleteAppointment, fetchAppointments } = useAppointments();
    const { fetchCustomerSlug } = useCustomerContext();
    
    useEffect(() => {
        fetchCustomerSlug(id);
        fetchAppointments(id, true);
    }, [id]);

    const visibleAppointments = showCompletedAppointments
        ? appointments
        : appointments.filter((appointment) => isAfter(new Date(appointment.date), new Date()));

    return (
    <div className="cudeContentContainer">
        <div className="cudeHeadingContainer">
            <h3>Anstehende Termine</h3>
        </div>
        {createAppointment && <CreateAppointment onClose={() => setCreateAppointment(false)} />}
        {visibleAppointments.length === 0 ? (
            <div className="cudeCard">
                <p>{showCompletedAppointments ? 'Keine erledigten Termine vorhanden' : 'Keine offenen Termine vorhanden'}</p>
            </div>
        ) : (
            visibleAppointments.map((appointment, index) => (
                <div key={index} className="cudeCard">
                    <p><strong>Datum:</strong> {appointment.formattedDate}</p>
                    <p><strong>Notiz:</strong> {appointment.description}</p>
                    <button onClick={() => deleteAppointment(appointment._id)}>
                        Termin löschen
                    </button>
                </div>
            ))
        )}
        <Button buttonType='button' buttonValue='Neuer Termin' onClick={() => setCreateAppointment(true)} />
        {appointments.some((appointment) => !isAfter(new Date(appointment.date), new Date())) && (
            <Button
                buttonType='button'
                buttonValue={showCompletedAppointments ? 'Erledigte Termine ausblenden' : 'Erledigte Termine anzeigen'}
                onClick={() => setShowCompletedAppointments((prev) => !prev)}
            />
        )}
    </div>
    );  
}

export default CuDeAppointment;